var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",class:_vm.$style.personalWrapper,attrs:{"fluid":""}},[_c('transition',{staticStyle:{"height":"100%"},attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }